module.exports = __webpack_public_path__ + "img/finance-settlement.3b879923.svg";